<script lang="ts">
	const { unijsLink }: { unijsLink?: string } = $props();
</script>

{/* eslint-disable @typescript-eslint/no-unused-vars */ null}
<svelte:head>
	{#if unijsLink}
		{@html `
        <script type="text/javascript" src="${unijsLink}"></script>
        <script type="text/javascript">
            let gdpr_kwk = 0;
            let gdpr_consent = '';

            const whenCmpReady = (tcData, success) => {
                if (success) {
                    const vendorConsent = tcData.vendor.consents[702];
                    if (true === vendorConsent) {
                        gdpr_kwk = 1;
                        gdpr_consent = tcData['tcString'];
                    }

                    __tcfapi("removeEventListener", 2, () => { }, tcData.listenerId);
                }
            };
            __tcfapi("addEventListener", 2, whenCmpReady);
        </script>
        `}
	{/if}
</svelte:head>
{/* eslint-enable @typescript-eslint/no-unused-vars */ null}
